import React, { useContext, useEffect, useState } from 'react'
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import MultiSelectEntity from '../RefineSearch/MultiSelectEntity';
import Popup from '../Common/Popup';
import useModule from '../../hooks/useModule';

/**
 * The CityFilter function is a component in JavaScript that renders a filter for selecting cities,
 * with options to select all cities or individual cities.
 * @returns a JSX element.
 */
function CityFilter({ CityOptions, setCityOptions, isCharge, customPathname, filterPathkey = "city", label = "City", innerCity, isPopupOpen, setIsPopupOpen }) {
    const { refineSearchFilters, accessControl } = useContext(PeFilterContext);
    const [internalPopupOpen, setInternalPopupOpen] = useState(false);
    const popupOpen = isPopupOpen !== undefined ? isPopupOpen : internalPopupOpen;
    const setPopupOpen = setIsPopupOpen !== undefined ? setIsPopupOpen : setInternalPopupOpen;
    const [CitySearchText, setCitySearchText] = useState("");
    const { isPE, isVC, isMA } = useModule();

    useEffect(() => {
        const ids = refineSearchFilters[customPathname]?.[filterPathkey]?.map(value => value.id) ?? [];
        setCityOptions(CityOptions?.map(option => ({ ...option, isChecked: ids.includes(option.id) })))
    }, [customPathname, refineSearchFilters, filterPathkey])

    const handleCityChange = ((e) => {
        const { name, checked, id, filteredIds } = e.target;
        
        if (name === "allSelect") {
            let currentCities = CityOptions.map((city) =>
                ({ ...city, isChecked: checked })
            );
            setCityOptions(currentCities);
        } else if (name === "filteredSelect" && filteredIds) {
            let currentCities = CityOptions.map((city) => {
                if (filteredIds.includes(city.id)) {
                    return { ...city, isChecked: checked };
                }
                return city;
            });
            setCityOptions(currentCities);
        } else {
            let currentCities = CityOptions.map((city) => {
                const isNumeric = /^[0-9]+$/.test(id);
                const parsedId = isNumeric ? parseInt(id) : id;
                return city.id === (isCharge ? id : parsedId) 
                    ? { ...city, isChecked: checked } 
                    : city;
            });
            setCityOptions(currentCities);
        }
    });
    
    const limitedCityOptions = CityOptions?.slice(0, 850);
    var primaryCityOptions = CitySearchText?.length > 2 ? CityOptions : limitedCityOptions;
    const selectedCityCount = CityOptions?.filter(option => option.isChecked)?.length ?? 0

    const enabledCities = accessControl ? (isPE || isVC ? accessControl?.pe_cities?.id : isMA && label !== "Acquirer City" ? accessControl?.ma_cities.id : []) : [];
    const disabledCities = enabledCities?.length > 0 ? CityOptions?.filter(op => !enabledCities?.includes(op.id)) : [];

    return (
        <div className="relative w-full md:inline-block">
            <button
                type="button"
                className="h-10 rounded-md px-4 py-1 text-gray-500 hover:bg-gray-100  text-sm shadow-md border border-gray-300 text-left flex items-center justify-between w-full md:w-[90%]"
                onClick={() => setPopupOpen(!popupOpen)}
            >
                <span className="truncate pr-2">{label} <span className="opacity-60 ml-2 text-xs text-ellipsis">e.g. Bangalore, Mumbai</span></span>
                <div className="flex items-center gap-2 flex-shrink-0">
                    {selectedCityCount > 0 && (
                        <span className="bg-white rounded-full px-2 py-0.5 text-xs font-medium border border-gray-400">
                            {selectedCityCount}
                        </span>
                    )}
                    <span className={`transition-transform duration-200 text-xl font-semibold ${popupOpen ? 'rotate-[270deg]' : 'rotate-90'}`}>
                        ›
                    </span>
                </div>
            </button>

            {popupOpen && (
                <Popup onClose={() => setPopupOpen(false)} label={label}>
                    <div className="p-4">
                        <MultiSelectEntity
                            handleEntityChange={handleCityChange}
                            primaryEntity={primaryCityOptions}
                            setCitySearchText={setCitySearchText}
                            disabled={disabledCities}
                        />
                    </div>
                </Popup>
            )}
        </div>
    )
}

export default CityFilter